'use client';

import React, { type ReactElement } from 'react';
import TenantSearchMain from './components/main.component';

export default function TenantSearchFeature(): ReactElement {
  return <TenantSearchMain />;
}
